import React from 'react';
import styles from './Headers.module.scss';

interface IComponentHeaderProps {
    title?: string | React.ReactNode;
    subtitle?: string;
    containerClassName?: string;
    rightSideComponent?: JSX.Element;
    useContainerFontSize?: boolean;
}

const ComponentHeader: React.FC<IComponentHeaderProps> = (props: IComponentHeaderProps) => (
    <div className={props.containerClassName ?? styles.component_header_container}>
        <div className={styles.component_header_flex}>
            <h3 className={!props.useContainerFontSize ? styles.component_header_main : styles.component_header_main_container}>{props.title}</h3>
            {props.rightSideComponent && <div className={styles.master_flex_and_float_right}>{props.rightSideComponent}</div>}
        </div>

        {props.subtitle && <h2 className={styles.component_header_sub}>{props.subtitle}</h2>}
    </div>
);

export default ComponentHeader;
